import styled from 'styled-components';

import { OVERLAY_TYPES } from 'constants/constants';

import { device } from '../../helpers/screenSizes';

export const HeaderStyle = styled.div`
  padding: 0;
  color: var(--main-text-primary);
  background: var(--main-bg-surface);
  border-bottom: 1px solid var(--divider-primary);
  //have to keep z-index value for avoid overlap panel component. lixueying

  z-index: 9;
  @media ${device.down.md} {
    z-index: 2;
  }
  position: sticky;
  top: ${props => (props.isOptionsEnabled ? '0' : '0px')};
  left: 0;
  right: 0;

  .header {
    border-top: 2px solid var(--divider-primary); 
    display: flex;
    padding: 0;

    .header-wrapper {
      padding: 0 !important;
      margin: 0 !important;
      font-family: var(--fontRegular) !important;
    }

    .burger-menu-container {
      background: ${props => props.theme.primaryBackground};
      height: 97%;

      order: 6;
      @media ${device.down.md} {
        order: 5;
        height: 50%;
      }

      @media ${device.down.xxs} {
        flex: 0 0 8.33333%;
        max-width: 8.33333%;
      }
    }
  }
  .option-chain-header {
    border-top: 1px solid ${props => props.theme.primaryBackground};
    font-family: var(--fontRegular) !important;
  }
  .back-link {
    font-size: 14px;
    font-family: var(--fontRegular);
    line-height: 1.29;
    color: ${props => props.theme.primaryTheme};
  }
  &.option-chain-header-style {
    border-bottom: 1px solid ${props => props.theme.primaryBackground};
  }

  .sub-text {
    padding: 0 0.8rem;
  }
  .header-info {
    order: 2;
    border-left: 2px solid ${props => props.theme.primaryBackground};
    border-right: 2px solid ${props => props.theme.primaryBackground};

    @media ${device.down.md} {
      order: 6;
      border-top: 2px solid ${props => props.theme.primaryBackground};
      border-left: 0px;
      border-right: 0px;
    }

    @media ${device.down.sm} {
      border-top: 2px solid ${props => props.theme.primaryBackground};
      border-left: 1px solid ${props => props.theme.primaryBackground};
      border-right: 1px solid ${props => props.theme.primaryBackground};
    }
  }

  .currency-conversion {
    order: 3;
    background: ${props => props.theme.primaryBackground};
    border-left: 2px solid ${props => props.theme.primaryBackground};
    border-right: 2px solid ${props => props.theme.primaryBackground};

    @media ${device.down.lg} {
      order: 2;
      font-size: 12.1px;
    }

    @media ${device.down.sm} {
      border-left: 2px solid ${props => props.theme.primaryBackground};
      border-right: 2px solid ${props => props.theme.primaryBackground};
    }
  }

  .coin-details {
    z-index: ${props =>
      props.currentShownOverlay === OVERLAY_TYPES.BALANCE_MENU ? '5' : '0'};
    order: 4;
    border-right: 2px solid ${props => props.theme.primaryBackground};
    border-left: 2px solid ${props => props.theme.primaryBackground};
    padding: 0;

    @media ${device.down.md} {
      order: 3;
    }

    @media ${device.down.sm} {
      border-left: 0px;
      border-right: 2px solid ${props => props.theme.primaryBackground};
    }
  }

  .signin-details {
    order: 4;
    border-right: 2px solid ${props => props.theme.primaryBackground};
    border-left: 2px solid ${props => props.theme.primaryBackground};

    @media ${device.down.md} {
      order: 3;
    }

    @media ${device.down.sm} {
      border-left: 2px solid ${props => props.theme.primaryBackground};
      border-right: 2px solid ${props => props.theme.primaryBackground};
    }
  }

  .header-notifs {
    order: 5;
    border-right: 2px solid ${props => props.theme.primaryBackground};

    @media ${device.down.md} {
      order: 4;
    }

    @media ${device.down.sm} {
      border-right: 2px solid ${props => props.theme.primaryBackground};
    }
  }

  .header-data-group-desktop {
    height: 100%;
    background: ${props => props.theme.primaryBackground};
    display: flex;
  }

  .desktop-md {
    display: block;
    @media ${device.down.sm} {
      display: none;
    }
  }

  .headerdropdownbox {
    cursor: pointer;
    padding: 4px 2px 2px 2px;
    z-index: ${props =>
      props.currentShownOverlay === OVERLAY_TYPES.CONTRACT_DROPDOWN ? '5' : '1'};
    order: 2;
    background-image: ${props => props.theme.primaryTheme};
    height: 97%;
  }

  .headerlastprice {
    padding: 8px 24px;
    order: 2;
    border-right: 2px solid ${props => props.theme.primaryBackground};
    display: flex;
    align-item: center;
  }

  .headeroptions {
    order: 3;
    display: flex;
    border-right: 2px solid ${props => props.theme.primaryBackground};
    border-left: 2px solid ${props => props.theme.primaryBackground};
    @media ${device.down.md} {
      order: 6;
      border-top: 2px solid ${props => props.theme.primaryBackground};
      border-left: 0px;
      height: 32px;
    }
  }

  .blankheader {
    order: 2;

    .deposit-button {
      position: absolute;
      right: 12px;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .header24hrchange {
    padding: 8px 5px 8px 5px;
    border-left: 2px solid ${props => props.theme.primaryBackground};
    order: 3;
    @media ${device.down.md} {
      padding: 4px 8px;
      border-left: 2px solid ${props => props.theme.primaryBackground};
      border-top: 2px solid ${props => props.theme.primaryBackground};
      order: 8;
    }
  }

  .header-row {
    height: 100%;
  }

  .initial-padding {
    padding-left: 6px !important;

    @media ${device.down.sm} {
      padding-left: 2px !important;
    }
  }

  .mobile-height {
    @media ${device.down.md} {
      height: 48px;
    }
  }

  .gradient-effect {
    background-image: linear-gradient(
      98deg,
      ${props => props.theme.primaryBackground}1A,
      ${props => props.theme.negative}1A
    );
    @media ${device.down.sm} {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }

  .tab-alignment {
    @media ${device.down.md} {
      display: flex;
      justify-content: center;
    }
  }
`;

export const BrandWrapper = styled.div`
  min-width: fit-content;
  color: ${props => props.theme.primaryText};
  font-size: 12.1px;
  line-height: 1.55;
  text-align: left;
  letter-spacing: 3.2px;
  order: 1;
  border-right: ${props => (props.showBorder ? '2' : '0')}px solid
    ${props => props.theme.primaryBackground};

  @media ${device.down.md} {
    border-right: ${props => (props.showBorder ? '2' : '0')}px solid
      ${props => props.theme.primaryBackground};
  }

  .org-logo {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.primaryBackground};
    height: 97%;
  }

  .sub-text {
    font-family: var(--fontRegular);
    padding-top: 5px;
    color: ${props => props.theme.primaryText};
  }

  .sub-text.active {
    color: ${props => props.theme.primaryText};
  }

  .sub-text:hover {
    color: ${props => props.theme.primaryText};
  }

  .sub-text.active:hover {
    color: ${props => props.theme.primaryText};
  }

  .logo {
    width: 103px;
    height: 32px;
  }

  .logo-small {
    width: 25px;
    height: 24px;
  }

  .logo.active {
    width: 50px;
    height: 50px;
  }

  .brand {
    display: flex;
    align-items: center;
  }
`;

export const MenuWrapper = styled.div`
  .bm-menu {
    z-index: 100;
    background: ${props => props.theme.primaryBackground};
    border-left: 2px solid ${props => props.theme.primaryBackground};
    border-bottom: 2px solid ${props => props.theme.primaryBackground};

    @media ${device.down.sm} {
      border-left: 2px solid ${props => props.theme.primaryBackground};
      border-bottom: 2px solid ${props => props.theme.primaryBackground};
    }

    @media ${device.down.md} {
      max-height: 420px;
      overflow-y: scroll;
      position: relative;
    }
  }

  .bm-menu-wrap {
    width: 235px !important;
    top: 75px;
    height: auto !important;

    @media ${device.down.xl} {
      top: 72px !important;
    }
    @media ${device.down.md} {
      top: 56px !important;
    }
    @media ${device.down.sm} {
      top: 44px !important;
    }
    @media ${device.down.xs} {
      width: 215px !important;
    }
  }

  .bm-burger-button {
    margin: 13px 15px;

    @media ${device.down.lg} {
      margin: 12px 10px;
    }

    @media ${device.down.sm} {
      margin: 10px;
    }
  }
`;

export default HeaderStyle;
